import "./testGenAI.css";
import ScheduleTwoToneIcon from "@mui/icons-material/ScheduleTwoTone";
import RateReviewTwoTone from "@mui/icons-material/RateReviewTwoTone";
import { Button} from "@mui/material";

const TopBar = ({
  showNewChat,
  showHistoryButton,
  displayName,
  onNewChat,
  onViewHistory,
}) => {
  return (
    <div className="card  custcard">
      <div className="cord-body">
         
        <div className="testHeading chatHeading">
          <label
            id="TestResult"
            className="testResultLabel"
            aria-label={displayName}
          >
            <center>{displayName} </center>
          </label>

          {showHistoryButton && (
            <Button
              id="chatHistBtn"
              variant="outlined"
              startIcon={<ScheduleTwoToneIcon />}
              size="small"
              className="topBarBtn"
              style={{ marginRight: "10px" }}
              onClick={onViewHistory}
            >
              Chat History
            </Button>
          )}
          {showNewChat && (
            <Button
              id="newChat"
              variant="outlined"
              startIcon={<RateReviewTwoTone />}
              size="small"
              className="topBarBtn"
              onClick={onNewChat}
            >
              New Chat
            </Button>
          )}
        </div>
      </div>

    </div>
  );
};

export default TopBar;
